import type { WaveGallerySection, WaveRecord } from "@vida/wave-core";

export function normalizeSearchQuery(search: string): string {
  return search.trim().toLowerCase();
}

export function filterWavesBySearch(waves: WaveRecord[], search: string): WaveRecord[] {
  const q = normalizeSearchQuery(search);
  if (!q) return waves;
  return waves.filter((wave) => wave.title.toLowerCase().includes(q));
}

export function filterInboxSectionsBySearch(
  sections: WaveGallerySection[],
  search: string,
): WaveGallerySection[] {
  const q = normalizeSearchQuery(search);
  if (!q) return sections;
  return sections
    .map((section) => ({
      ...section,
      waves: filterWavesBySearch(section.waves, search),
    }))
    .filter((section) => section.waves.length > 0);
}

export function filterSpacesBySearch<T extends { title: string }>(
  spaces: T[],
  search: string,
): T[] {
  const q = normalizeSearchQuery(search);
  if (!q) return spaces;
  return spaces.filter((space) => space.title.toLowerCase().includes(q));
}
